import React from 'react';
import FindServicePage from './FindServicePage';

const FindRecoveryPage = () => <FindServicePage endpoint="recoveryservices" breadcrumbs={['toolsTitle', 'toolsFindRecovery']} />;

export default FindRecoveryPage;
